import { useEffect } from 'react';

const useDocumentTitle = title => {
  useEffect(() => {
    document.title = `${title} | Guesty`;
  }, [title]);
};
export default useDocumentTitle;
